import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class PickService {
  private apiUrl = '/picks';
  private apiSpringUrl = '/spring/picks';

  constructor(
    private http: HttpService) { }

  get(ownerId?: number, stpickId?: number): Promise<any> {
    // tslint:disable-next-line:max-line-length
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}?ownerId=${ownerId}&stpickId=${stpickId}`;
    return this.http.get(url);
  }

  post(jsonData:any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}`;
    return this.http.post(url, jsonData);
  }

  exportAllPick(ownerId?: number): Promise<any> {
    const jsonData = {"ownerId": ownerId}
    const url = `${environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl}/exportAll`;
    return this.http.post(url, jsonData);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/pick/pick.service.ts